<template>
  <main class="main page-inside faq-page">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">General Questions</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <div class="section page-body-section">
        <div class="circle"></div>
        <div class="circle-2"></div>
        <div class="circle-3"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="wrapper">
          <div
            class="accordion-list"
            v-for="(items, category, index) in groupedFaqs"
            :key="index"
          >
            <div class="title title-64">{{ category }}</div>
            <div
              :class="['accordion-item', { active: isActivePanel(item.id) }]"
              @click="togglePanel(item.id)"
              v-for="item in items"
              :key="item.id"
            >
              <div class="desc desc-20">
                <b>{{ item.question }}</b>
              </div>
              <div class="desc" v-if="isActivePanel(item.id)">
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "Faq",
  props: [],
  components: {},
  data: function () {
    return {
      faq: [],
      activePanels: [],
    };
  },
  mounted() {
    this.faq = [
      {
        title: "General Information",
        list: [
          {
            id: 1,
            question: "What is BlockWrld?",
            answer:
              "BlockWrld is an independent Minecraft server platform where players can explore diverse worlds, meet new friends, and enjoy unique gameplay experiences. Remember, we are not affiliated with Mojang or Microsoft.",
          },
          {
            id: 2,
            question: "How do I start playing on BlockWrld?",
            answer:
              "First, you need to register on our server by joining through your Minecraft client with the server IP provided on our website. Once registered, you can access various worlds and make purchases on our site.",
          },
        ],
      },
      {
        title: "In-game Purchases",
        list: [
          {
            id: 3,
            question: "How do I make in-game purchases?",
            answer:
              "To buy items, head to the shop section on our website. You`ll need to enter your Minecraft nickname—the one you registered with on the server. After your purchase, the items will automatically appear in your game inventory.",
          },
          {
            id: 4,
            question: "What can I buy in the in-game shop?",
            answer:
              "Our shop offers a variety of items that can enhance your gameplay, including exclusive tools, skins, and special abilities. All items available for purchase are listed in the shop section of our website.",
          },
          {
            id: 5,
            question: "How do I ensure my purchase goes to my game account?",
            answer:
              "Make sure to use the exact Minecraft nickname you registered with on our server when making a purchase. This is how our system identifies your account to deliver your items correctly.",
          },
        ],
      },
      {
        title: "Payment Questions",
        list: [
          {
            id: 6,
            question: "What payment methods are accepted?",
            answer:
              "Currently, we accept Visa and MasterCard credit/debit cards for all purchases. We ensure all transactions are secure and encrypted.",
          },
          {
            id: 7,
            question:
              "Is it safe to enter my payment information on your website?",
            answer:
              "Absolutely. Our website uses SSL encryption to protect your personal and payment information. Your security is our top priority. ",
          },
        ],
      },
      {
        title: "Troubleshooting",
        list: [
          {
            id: 8,
            question: "What should I do if I don’t receive my purchase?",
            answer:
              "If you encounter any issues with your purchese, please contact our support team immediately. Provide your transaction details and nickname, and we’ll resolve the issue as quickly as possible.",
          },
          {
            id: 9,
            question: "Can I get a refund for my purchase?",
            answer:
              "Refunds are considered on a case-by-case basis. If you feel there has been a mistake or if you’re dissatisfied with your purchase, please contact our support team with the details of your purchase.",
          },
        ],
      },
      {
        title: "Additional Information",
        list: [
          {
            id: 10,
            question: "Can I play on BlockWrld without making any purchases?",
            answer:
              "Yes! You can enjoy many features of our servers without making any purchases. In-game purchases are completely optional and provide additional ways to enhance your gameplay experience.",
          },
        ],
      },
    ];
  },
  computed: {
    groupedFaqs() {
      const groups = {};
      if (this.$parent.faq) {
        this.$parent.faq.forEach((faq) => {
          if (!groups[faq.category]) {
            groups[faq.category] = [];
          }
          groups[faq.category].push(faq);
        });
      }

      return groups;
    },
  },
  methods: {
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index);
    },
  },
};
</script>
